import SectionOne from "../components/single-portfolio/section-one";
import BreadcrumbOne from "./../components/common/breadcrumb/breadcrumb-one";
export default function SinglePortFolio() {
	return (
		<>
			<BreadcrumbOne title="Artwork wall printing" />
			<SectionOne />
		</>
	);
}
